var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C11.5 4.82843 10.8284 5.5 10 5.5C9.17158 5.5 8.5 4.82843 8.5 4C8.5 3.17157 9.17158 2.5 10 2.5C10.8284 2.5 11.5 3.17157 11.5 4Z",
    fill: "#9AA7BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17158 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17158 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10Z",
    fill: "#9AA7BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16C11.5 16.8284 10.8284 17.5 10 17.5C9.17158 17.5 8.5 16.8284 8.5 16C8.5 15.1716 9.17158 14.5 10 14.5C10.8284 14.5 11.5 15.1716 11.5 16Z",
    fill: "#9AA7BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/moreVertical.62be4d2b5f8e2999c7792da48c412717.svg";
export { ForwardRef as ReactComponent };